import styled from "styled-components";

export const ContainerFooter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-area: footer;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
    width: 100%;
    background-color: ${props => props.theme.colors.brand4.dark};
    min-height: 100px;   
    padding : 5px 14px;
    z-index:1 ;    
`